import omit from 'lodash/omit';
import type { OutputLabelledDataT } from '../types';
const mediaUrlKeys = ['mediaUrl', 'imageUrl', 'videoUrl', 'pdfUrl'];
interface IProps<TaskDataT extends OutputLabelledDataT> {
  taskDataInput: TaskDataT;
  taskDataOutput?: TaskDataT;
  localData?: TaskDataT;
}
export function mergeTaskData<TaskDataT extends OutputLabelledDataT>({
  taskDataInput,
  taskDataOutput,
  localData
}: IProps<TaskDataT>): TaskDataT {
  const taskInput = taskDataInput || ({} as TaskDataT);
  const taskOutput = taskDataOutput || ({} as TaskDataT);
  const taskBackup = localData || ({} as TaskDataT);
  const taskOutputWithoutMediaUrl = omit(taskOutput, mediaUrlKeys);
  const taskBackupWithoutMediaUrl = omit(taskBackup, mediaUrlKeys);
  const data = {
    ...taskInput,
    ...taskOutputWithoutMediaUrl,
    ...taskBackupWithoutMediaUrl
  };
  return data;
}